import React from 'react';

export default function Page404() {
    return (
        <>
            <h3> Page does not exist. </h3>
        </>

    );
}